<template>
  <div class="custom-select-box" :tabindex="tabindex" @focusout="handleFocusOut">
    <div class="selected" :class="{ open: open }" @click="open = !open" data-testid="study-auto-complete">
      <span v-if="selected">
        {{ selected.name }}
      </span>
      <span v-else class="select-study">Search Study</span>
    </div>
    <div class="items" :class="{ selectHide: !open }">
      <input v-model="searchTerm" type="text" :placeholder="!selected ? 'Search Study' : ''" class="form-control" @input="filterStudies()" ref="searchInput" />
      <div class="studies-list">
        <div class="item" v-for="option of filteredStudies" :key="`study-id-${option.studyId}`" @click="selectOption(option)" :data-testid="`study-option-${option.studyId}`">
          {{ option.name }}
        </div>
        <div v-if="filteredStudies && !filteredStudies.length" class="no-studies">
          No studies found.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { cloneDeep, find } from "lodash";
export default {
  name: "StudiesAutoCompleteDropDown",
  props: {
    options: {
      type: Array,
      required: true
    },
    tabindex: {
      type: Number,
      required: false,
      default: 0
    },
    selectedOption: {
      default: null
    }
  },
  watch: {
    open() {
      this.$nextTick(() => {
        this.$refs.searchInput.focus();
      });
    },
    selectedOption: {
      handler(selectedStep) {
        if (!selectedStep) {
          this.selected = null;
          return;
        }
        if (this.selected && selectedStep.studyId == this.selected.studyId) {
          return;
        }

        this.selected = find(this.options, {
          studyId: selectedStep.studyId
        });
      },
      deep: true
    },
    options: {
      handler(soptions) {
        this.filteredStudies = cloneDeep(soptions);
      },
      deep: true
    },
    searchTerm(term) {
      if (term.trim() == "") {
        this.filteredStudies = cloneDeep(this.options);
      }
    }
  },
  data() {
    return {
      filteredStudies: cloneDeep(this.options),
      selected: null,
      open: false,
      searchTerm: ""
    };
  },
  methods: {
    selectOption(option) {
      this.searchTerm = "";
      this.selected = option;
      this.open = false;
      this.$emit("input", option);
    },
    handleFocusOut(event) {
      if (!event.currentTarget.contains(event.relatedTarget)) {
        this.open = false;
        //Set the search term to empty so that once after reopening the modal/clicking on the search input user get all the studies options
        this.searchTerm = "";
      }
    },
    filterStudies: function() {
      let self = this;
      if (this.searchTerm.trim() != "") {
        this.filteredStudies = this.options.filter(function(element) {
          return element.name.toLowerCase().indexOf(self.searchTerm.toLowerCase()) === 0;
        });
      } else {
        this.filteredStudies = cloneDeep(self.options);
      }
    }
  },
  mounted() {
    this.$emit("input", this.selected);
  }
};
</script>

<style lang="scss" scoped>
.custom-select-box {
  position: relative;
  width: 100%;
  text-align: left;
  outline: none;
  font-size: 12px;
  font-weight: normal;

  .selected {
    background-color: #ffffff;
    border-radius: 4px;
    border: solid 1px #d3dfe4;
    color: #4a4a4a;
    font-family: Roboto-Medium;
    font-size: 14px;
    padding: 12px;
    padding-left: 11px;
    cursor: pointer;
    user-select: none;
    text-transform: capitalize;

    .select-study {
      color: #e0e0e0;
      font-family: Roboto-Medium;
      font-size: 14px;
    }
  }

  .items {
    color: #666669;
    position: absolute;
    z-index: 1;
    left: 0;
    right: 0;
    top: 0;
    font-family: Roboto-Medium;
    font-size: 14px;
    &.selectHide {
      display: none;
    }

    input {
      padding: 12px;
      &:focus {
        border-color: #3d82e3;
        box-shadow: none;
      }
    }

    .studies-list {
      overflow: hidden;
      max-height: 264px;
      min-height: 42px;
      overflow-y: auto;
      border-radius: 9px;
      border: solid 1px #d3dfe4;
      background-color: #ffffff;
      padding: 2px;
      margin-top: 1px;

      scroll-behavior: smooth;
      //Scrollbar CSS for Mozilla
      scrollbar-color: #abb4b9 white; /* thumb and track color */
      scrollbar-width: thin;

      //Below is the scrollbar css for Chrome
      &::-webkit-scrollbar {
        width: 6px;
        background-color: #ffffff;
      }
      &::-webkit-scrollbar-thumb {
        background-color: #abb4b9;
        border-radius: 20px;
      }
      &::-webkit-scrollbar-track {
        background-color: #ffffff;
      }

      .no-studies {
        padding: 16px;
        text-align: center;
        opacity: 0.9;
      }
    }

    .item {
      color: #666669;
      cursor: pointer;
      user-select: none;
      padding: 16px;
      border-radius: 4px;
      width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      &:hover {
        background-color: #4c8ce4;
        color: #ffffff;
      }
    }
  }
}
</style>
